import { api, devAgentAuthHeaders, unwrap, withUserId } from "./core";
import type { DependencySnapshot, PostSaveAnalysisResult } from "./types";

export const validateAndSave = async (
  sessionUuid: string,
  params: {
    class_name: string;
    content: string;
    metadata_type?: string;
  },
): Promise<{
  valid: boolean;
  saved: boolean;
  attempts: number;
  errors?: any[];
  dependent_classes?: string[];
}> =>
  unwrap(
    (
      await api.post(
        withUserId(`/api/chat/sessions/${sessionUuid}/validate-save`),
        params,
        { timeout: 300000, headers: devAgentAuthHeaders() },
      )
    ).data,
  );

export const runPostSaveAnalysis = async (
  sessionUuid: string,
  params: {
    class_name: string;
    metadata_type?: string;
  },
): Promise<PostSaveAnalysisResult> =>
  unwrap(
    (
      await api.post(withUserId(`/api/chat/sessions/${sessionUuid}/analyze`), params, {
        timeout: 120000,
        headers: devAgentAuthHeaders(),
      })
    ).data,
  );

export const runApexTest = async (
  sessionUuid: string,
  params: {
    test_class: string;
  },
): Promise<{
  success: boolean;
  result: any;
  class_name: string;
  production_class?: string | null;
  covered_classes?: Array<{
    name: string;
    coverage_pct: number | null;
    covered_lines: number[];
    uncovered_lines: number[];
    num_covered: number;
    num_uncovered: number;
  }>;
  passed?: number;
  failed?: number;
  total?: number;
}> =>
  unwrap(
    (
      await api.post(withUserId(`/api/chat/sessions/${sessionUuid}/run-test`), params, {
        timeout: 180000,
        headers: devAgentAuthHeaders(),
      })
    ).data,
  );

export const getCoverageLines = async (
  sessionUuid: string,
  params: {
    class_name: string;
  },
  silent = false,
): Promise<{
  class_name: string;
  covered_lines: number[];
  uncovered_lines: number[];
  coverage_pct: number | null;
}> =>
  unwrap(
    (
      await api.post(
        withUserId(`/api/chat/sessions/${sessionUuid}/coverage-lines`),
        params,
        { timeout: 30000, silent, headers: devAgentAuthHeaders() } as any,
      )
    ).data,
  );

export const fixCode = async (
  sessionUuid: string,
  params: {
    class_name: string;
    content: string;
    errors: Array<{ message: string }>;
    metadata_type?: string;
  },
): Promise<{ fixed: boolean; content: string; errors_addressed: string[] }> =>
  unwrap(
    (
      await api.post(withUserId(`/api/chat/sessions/${sessionUuid}/fix-code`), params, {
        timeout: 60000,
        headers: devAgentAuthHeaders(),
      })
    ).data,
  );

export type { DependencySnapshot };
